module.exports = __webpack_public_path__ + "img/aParty_121223_F.554b276a.jpg";